<template>
    <fieldset :disabled="loading">
        <div class="modal fade show" style="display: block" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{finalizer.TargetSystem.Name}}</h5>
                    <button type="button" class="close" data-dismiss="modal"  :aria-label="translate('close')" @click="$emit('onclose')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-7">
                            <pre>{{value}}</pre>
                        </div>
                        <div class="col-5">

                        </div>
                    </div>

                </div>
                <div class="modal-footer footer-button-container">
                    <button type="button" class="btn btn-outline-secondary" @click="$emit('onclose')">{{translate('close')}}</button>
                    <!-- <button type="submit" class="btn btn-success" style="width:100px;" @click="$refs.imzalayici.sign()">İmzala</button> -->
                </div>
                </div>
            </div>
        </div>
    </fieldset>
</template>
<script>
export default {
    props: ['value']
}
</script>
